module.exports = __webpack_public_path__ + "static/media/hospital.2666c8bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/hospital.svg
// module id = 1482
// module chunks = 0